import auth from '@modules/auth';
import standard from '@modules/standard';
import adultsOnly from '@modules/adultsOnly';
import actionGenre from '@modules/actionGenre';
import bodyPart from '@modules/bodyPart';
import etc from '@modules/etc';
import facialExpression from '@modules/facialExpression';
import metaTag from '@modules/metaTag';
import comic from '@modules/comic';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector as uS, useDispatch as uD } from 'react-redux';
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

const persistConfig = {
  // config 작성
  key: 'root',
  storage: storageSession,
  whiteList: ['auth', 'standard', 'adultsOnly', 'actionGenre', 'facialExpression', 'etc', 'metaTag', 'comic'] // 적용할 리듀서를 whiteList에 포함시킨다.
};

const rootReducer = combineReducers({
  auth,
  standard,
  adultsOnly,
  actionGenre,
  bodyPart,
  facialExpression,
  etc,
  metaTag,
  comic
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false // 비직렬화 값 체크 비활성화
    })
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useSelector: TypedUseSelectorHook<RootState> = uS;
export const useDispatch = () => uD<AppDispatch>();
